<template>
  <div class="d-flex mb-2" :style="{ maxHeight: 38 + 'px' }">
    <div class="pl-0 col-3 text-left align-self-end">
      <span>{{ $t('profile_herbariums_table_genus') }}</span>
    </div>
    <div class="col">
      <Multiselect
        v-model="value"
        :options="getGenus"
        label="name"
        track-by="id"
        :placeholder="$t('filter_bar_label_multi')"
        :select-label="$t('vue_multi_select_enter')"
        :deselect-label="$t('vue_multi_select_remove')"
        :selected-label="$t('vue_multi_select_selected_label')"
        :multiple="true"
        @search-change="search"
        @remove="remove"
        @close="close"
      >
        <template slot="noOptions">
          <span>{{ $t('vue_multi_select_no_options') }}</span>
        </template>
        <template slot="noResult">
          <span>{{ $t('vue_multi_select_no_result') }}</span>
        </template>
      </Multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  components: { Multiselect },
  props: {
    family: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      value: []
    }
  },
  computed: mapGetters(['getGenus']),
  watch: {
    family: function(newVal) {
      if (newVal.length) {
        this.$store.dispatch('requestDataGenus', newVal)
      }
    }
  },
  methods: {
    search(value) {
      if (value.length >= 2 && !this.family.length) {
        this.$store.dispatch('requestDataGenusName', value)
      }
    },
    remove(item) {
      this.$emit(
        'change-selected',
        'genus',
        this.value.filter(el => el.id !== item.id)
      )
    },
    close() {
      this.$emit('change-selected', 'genus', this.value)
    }
  }
}
</script>

<style></style>
